export const AlertStateDropdown = [
    {
      label: "OPEN",
      value: "OPEN",
    },
    {
      label: "CLOSED",
      value: "CLOSED",
    },
    {
      label: "ACKNOWLEDGED",
      value: "ACKNOWLEDGED",
    },
    {
      label: "RECOVERED",
      value: "RECOVERED",
    },
  ];
  